export default "__VITE_ASSET__CtqkOhEp__";